import { render } from "./NotificationPanelTab.vue?vue&type=template&id=52d98bc2&scoped=true"
import script from "./NotificationPanelTab.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationPanelTab.vue?vue&type=script&setup=true&lang=js"

import "./NotificationPanelTab.vue?vue&type=style&index=0&id=52d98bc2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d98bc2"],['__file',"Shared/components/notifications/EnNotificationPanel/NotificationPanelTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52d98bc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52d98bc2', __exports__)) {
    api.reload('52d98bc2', __exports__)
  }
  
  module.hot.accept("./NotificationPanelTab.vue?vue&type=template&id=52d98bc2&scoped=true", () => {
    api.rerender('52d98bc2', render)
  })

}


export default __exports__